<template>
  <div class="row">
    <div
      class="login-sidebar"
    >
      <div class="abc">
        <object
          data="assets/img/go-logo-horz.svg"
          style="height: 36px; width: 176px"
        ></object>
      </div>
      <div>
        <img
          src="assets/img/box-pack.png"
          width="50%"
          class="side_img"
        />
        <img
          src="assets/img/box-round-grn.png"
          width="50%"
          class="side_img"
          style="margin-right:-10px"
        />

        <img src="assets/img/box-round-blu.png" width="50%" class="side_img" />
        <img src="assets/img/box-dots.png" width="50%" class="side_img" />
        <img src="assets/img/box-double.png" width="100%" class="side_img"/>
      </div>
    </div>
    <div
      class="login_form"
      :class="accessStatus==request?'req_access_pad':''"
    >
      <div class="logo">
        <object data="assets/img/gk-logo-vert-1.svg"></object>
      </div>
      <div
        class="divider"
      ></div>
      <p class="wlcm_class">
        {{ showRequestAccess ? accessStatus : "Welcome back!" }}
      </p>
      <div
        class="form-group"
        v-if="showError"
        style="    width: 279px;
                    margin: auto;
                    height: 34px;"
      >
        <p
          class="register-question"
          style="    color: rgb(201, 63, 38);
                        font-family: Montserrat;
                    font-weight: 500;
                    text-align: center;
                    font-size: 12px;
                    letter-spacing: 0.04px;
                    line-height: 15px;"
        >
          {{errorMessage}}
        </p>
      </div>
      <div
        class="form-group"
        v-if="showResetPassword && !showError"
        style="    width: 279px;
                    margin: auto;
                    height: 34px;"
      >
        <p
          class="register-question"
          style="   font-family: Montserrat;
                    font-weight: 500;
                    text-align: center;
                    font-size: 12px;
                    letter-spacing: 0.04px;
                    line-height: 15px;"
        >
          A confirmation code has been sent to your email address.
        </p>
      </div>
      <p
        class="req_access"
        v-if="showRequestAccess"
      >
        {{ getRequestDescription() }}
      </p>
      <div
        class="form-group"
        v-if="
          !showResetPassword && !showRequestAccess || (showRequestAccess && accessStatus == request)
        "
      >
        <input
          v-model="email"
          name="email"
          type="email"
          id="email"
          class="form-input form-control input_placeholder email_inp"
          placeholder="E-mail address"
        />
      </div>
      <div class="form-group" v-if="!showRequestAccess && !showForgotPassword">
        <input
          v-model="password"
          name="pass"
          id="pass"
          class="form-input form-control input_placeholder pwd_inp"
          placeholder="Password"
          type="password"
        />
      </div>
      <div class="form-group" v-if="showResetPassword">
        <input
          v-model="confirmPassword"
          name="confirmPass"
          id="confirmPass"
          class="form-input form-control input_placeholder pwd_inp"
          placeholder="Confirm Password"
          type="password"
        />
      </div>
      <div class="form-group" v-if="showResetPassword">
        <input
          v-model="confirmationCode"
          name="confirmationCode"
          id="confirmationCode"
          class="form-input form-control input_placeholder pwd_inp"
          placeholder="Confirmation Code"
          type="text"
        />
      </div>
      <p
        style="
          color: #1e4c42;
          font-family: Montserrat;
          font-size: 12px;
          letter-spacing: 0.04px;
          line-height: 15px;
          text-align: center;
          margin: auto;
          margin-top: 15px;
          cursor: pointer;
          height: 24px;
        "
        @click="backToLogin()"
        v-if="
          showResetPassword || showForgotPassword || showRequestAccess &&
            (accessStatus == requestInProgress || accessStatus == requestFailed)
        "
      >
        Return to login
      </p>
      <div
        class="form-group"
        style="width: 333px; margin: auto; margin-top: 15px"
        v-if="!showRequestAccess && !showResetPassword && !showForgotPassword"
      >
        <label style="display: inline-flex">
          <input
            name="remember"
            type="checkbox"
            class="form-check"
            value="on"
            style="height: 13px; width: 13px"
          />
        </label>
        <span
          style="
            color: #000000;
            font-family: Montserrat;
            font-size: 12px;
            letter-spacing: 0.04px;
            line-height: 15px;
            margin: -4px 0px 0px 4px;
          "
          >Stay signed in</span
        >
        <!-- <a
          style="
            color: #1e4c42;
            font-family: Montserrat;
            font-size: 12px;
            letter-spacing: 0.04px;
            line-height: 15px;
            margin-left: 15px;
            cursor: pointer;
            margin-top: 5px;
          "
          @click="forgotPassword()"
          >Forgot Password</a
        > -->
        <a
          style="
            color: #1e4c42;
            font-family: Montserrat;
            font-size: 12px;
            letter-spacing: 0.04px;
            line-height: 15px;
            float: right;
            cursor: pointer;
            margin-top: 5px;
          "
          title="Open a service request in a new tab for GOALKeeper access"
          target="serviceRequest"
          href="https://globaloverview.atlassian.net/servicedesk/customer/portal/1/group/1/create/41"
          @click="reqAccessCalled()"
          >Request Access</a
        >
      </div>
      <div
        style="
          width: 157.5px;
          height: 45px;
          text-align: center;
          margin: auto;
          background-color: #ffbf3f;
          cursor: pointer;
          border-radius: 26.5px;
          display: table;
          margin-top: 15px;
        "
        v-if="
          !showForgotPassword && !showRequestAccess || (showRequestAccess && accessStatus == request)
        "
        @click="submitOnClick()"
      >
        <span
          style="
            color: #333333;
            font-family: Montserrat;
            font-size: 14px;
            font-weight:600;
            letter-spacing: 0.05px;
            line-height: 30px;
            text-align: center;
            display: table-cell;
            vertical-align: middle;
          "
        >
          {{
            showResetPassword || showRequestAccess && accessStatus == request ? "Submit" : "Sign in"
          }}
        </span>
      </div>
      <div
        style="
          width: 157.5px;
          height: 45px;
          text-align: center;
          margin: auto;
          background-color: #ffbf3f;
          cursor: pointer;
          border-radius: 26.5px;
          display: table;
          margin-top: 15px;
        "
        v-if="showForgotPassword"
        @click="resetPassword()"
      >
        <span
          style="
            color: #333333;
            font-family: Montserrat;
            font-size: 14px;
            font-weight:600;
            letter-spacing: 0.05px;
            line-height: 30px;
            text-align: center;
            display: table-cell;
            vertical-align: middle;
          "
        >Reset Password</span>
      </div>
      <div
        class="form-group"
        style="margin: auto; margin-top: 15px; align-items: center;  max-width: fit-content; margin-left:auto; margin-right: auto;"
        v-if="!showRequestAccess && !showResetPassword && !showForgotPassword"
      >
        <a
          style="
            color: #1e4c42;
            font-family: Montserrat;
            font-size: 12px;
            letter-spacing: 0.04px;
            line-height: 15px;
            cursor: pointer;
            margin-top: 5px;
          "
          @click="forgotPassword()"
          >Forgot Password</a
        >
      </div>
      <p
        style="
          color: #333333;
          font-family: Aleo;
          font-size: 15px;
          font-weight:400;
          letter-spacing: 0.33px;
          line-height: 18px;
          text-align: center;
          margin-top: 30px;
        "
        v-if="!showRequestAccess"
      >
        Powered by data, improved by humans.
      </p>
    </div>
  </div>
</template>


<script>
import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";
export default {
  data() {
    return {
      email: "",
      password: "",
      confirmPassword: "",
      confirmationCode: "",
      showError: false,
      errorMessage: "",
      showRequestAccess: false,
      accessStatus: "",
      request: "Request access",
      requestInProgress: "Access requested",
      requestFailed: "Were sorry…",
      newPasswordRequired: false,
      showResetPassword: false,
      showForgotPassword: false
    };
  },
  methods: {
    backToLogin() {
      this.accessStatus = "";
      this.showRequestAccess = false;
      this.showError = false;
      this.showResetPassword = false;
      this.showForgotPassword = false;
      this.confirmPassword = ""
      this.password = ""
      this.confirmationCode = ""
      this.email = ""
    },
    reqAccessCalled() {
      return
      this.accessStatus = this.request;
      this.showRequestAccess = true;
      this.showError = false
    },
    getRequestDescription() {
      if (this.accessStatus == this.request) {
        return "Please enter your Global Overview email address.";
      } else if (this.accessStatus == this.requestInProgress) {
        return "Please allow up to 72 hours for us to get back to you.";
      } else if (this.accessStatus == this.requestFailed) {
        return "Goalkeeper is currently only available for Global Overview and its partners.";
      }
    },
    signIn() {
      let vm = this;

      let authenticationData = {
        Username: vm.email,
        Password: vm.password,
      };
      var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
        authenticationData
      );

      var poolData = {
        UserPoolId: "us-east-1_KPh2ycnq4", // Your user pool id here
        ClientId: "1qe6ml4g9dh4c1sl5j99k8965j", // Your client id here
      };
      var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
      var userData = {
        Username: vm.email,
        Pool: userPool,
      };
      var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
      cognitoUser.authenticateUser(authenticationDetails, {
        newPasswordRequired: function(userAttributes, requiredAttributes) {
          console.log("newPasswordRequired");
          vm.newPasswordRequired = true;
          vm.errorMessage = `Password expired: please reset your password.`
          vm.showError = true;
        },
        onSuccess: function(result) {
          // console.log('Name + ' + result.idToken.payload.name);
          // console.log('ID token + ' + result.idToken.jwtToken);

          vm.showRequestAccess = false;
          let jsonData = {
            name: result.idToken.payload.name,
            idToken: result.idToken.jwtToken,
            accessToken: result.accessToken.jwtToken,
            username: vm.email,
          };
          //
          console.log("cognitoUser", cognitoUser);

          jsonData = JSON.stringify(jsonData);

          let loginDate = new Date();
          loginDate = loginDate.toDateString();

          window.localStorage.setItem("session", jsonData);
          window.localStorage.setItem("loginDate", loginDate);

          window.sessionStorage.setItem("session", jsonData);
          window.sessionStorage.setItem("loginDate", loginDate);
          let isdetail = localStorage.getItem("release:releasepath");
          if (isdetail == "" || isdetail == null || isdetail == "/") {
            vm.$router.push("/accounts");
            window.localStorage.setItem("release:releasepath", "");
          } else {
            vm.$router.push(isdetail);
          }
        },
        onFailure: function(err) {
          vm.errorMessage = `Either the email address or the password entered is incorrect.`
          console.log(err)
          // vm.errorMessage = err.message;
          vm.showError = true;
        },
      });
      return false;
    },
    resetPassword() {
      let vm = this;

      const poolData = {
        UserPoolId: "us-east-1_KPh2ycnq4", // Your user pool id here
        ClientId: "1qe6ml4g9dh4c1sl5j99k8965j", // Your client id here
      };
      const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
      const userData = {
        Username: vm.email,
        Pool: userPool,
      };
      
      const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

      cognitoUser.forgotPassword({
        onSuccess: function(result) {
            console.log('call result: ' + result);
            vm.showForgotPassword = false
            vm.confirmPassword = ""
            vm.password = ""
            vm.confirmationCode = ""
            vm.showResetPassword = true
        },
        onFailure: function(err) {
            console.log(err);
            vm.showError = true;
            vm.errorMessage = 'Failed to send confirmation code for password reset.'
            vm.email = ""
            vm.showForgotPassword = false
        }
    });

    },
    setNewPassword() {
      let vm = this;
      vm.showError = false

      if (vm.password !== vm.confirmPassword) {
        console.log(`Passwords do not match.`)
        vm.errorMessage = 'Passwords must match.'
        vm.showError = true
        return
      }

      const poolData = {
        UserPoolId: "us-east-1_KPh2ycnq4", // Your user pool id here
        ClientId: "1qe6ml4g9dh4c1sl5j99k8965j", // Your client id here
      };

      const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

      const userData = {
        Username: vm.email,
        Pool: userPool,
      };

      const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

      cognitoUser.confirmPassword(vm.confirmationCode, vm.password, {
          onFailure(err) {
              console.log(err);
              vm.showError = true;
              vm.errorMessage = 'Password reset failed.'
              vm.showResetPassword = false
              vm.confirmPassword = ""
              vm.password = ""
              vm.confirmationCode = ""
              vm.email = ""
          },
          onSuccess() {
              console.log("confirmPassword: Success");
              vm.showResetPassword = false
              vm.confirmPassword = ""
              vm.password = ""
              vm.confirmationCode = ""
              vm.email = ""
              vm.$router.go(0) //refresh the page after success, stops chromium from doing wonky stuff with autofill
          },
      });
    },
    forgotPassword() {
      this.showForgotPassword = true
      this.showError = false
      this.email = ""
    },
    submitOnClick(){
      if (this.showRequestAccess && this.accessStatus == this.request) {
        this.backToLogin()
      } else if (this.showResetPassword) {
        this.setNewPassword()
      }else{
        this.signIn()
      }
    }
  },
};
</script>
<style lang="scss">
.login_wrapper {
  .row {
    // @media (max-width: 1023px) {
    //   margin-right: 0px;
    //   margin-left: 0px;
    //   min-height: 780px !important;
    // }
    .login-sidebar {
      width:25%;background-color: #1e4c42;border-radius: 11px 0px 0px 11px;height: 100%;
      // @media (max-width: 1023px) {
      //   width: 390px !important;
      // }
      @media (min-width:1387px) and (min-height:850px){
        width: 30%;
      }
      img {
        // @media (max-width: 1023px) {
        //   height: auto;
        // }
      }
      .top_img {
        // @media (max-width: 1023px) {
        //   height: 195px;
        // }
      }
      .side_img{
        height: 118px;
        @media (min-width:1387px) and (min-height:850px){
          height: 202px;
        }

      }
    }
    .login_form {
      // width: calc(100% - 420px) !important;
      width:75%;
      height: 100%;
      background-color: #ffffff;
      padding-top: 105px;
      padding-bottom: 105px;
      border-radius:0px 11px 11px 0px;
      @media (min-width:1387px) and (min-height:850px){
        width: 70%;
        padding-top:170px;
        padding-bottom:170px;
      }
      &.req_access_pad{
        padding-top: 161px;
        padding-bottom: 161px;
        @media (min-width:1387px) and (min-height:850px){
          padding-top:226px;
          padding-bottom:226px;
        }
      }
      // @media (max-width: 1023px) {
      //   width: calc(100% - 390px) !important;
      //   padding-top: 104px !important;
      // }
      .logo{
        height: 100px; width: 183px; margin: auto;
      }
      .divider{
          box-sizing: border-box;
          height: 1px;
          width: 201px;
          border: 1px solid #979797;
          border-radius: 0.5px;
          background-color: #d8d8d8;
          margin: auto;
          margin-top: 31px;
        
      }
      .req_access{
          color: #333333;
          font-family: Montserrat;
          font-size: 12px;
          letter-spacing: 0.67px;
          line-height: 15px;
          text-align: center;
      }
      .email_inp{
            box-sizing: border-box;
            height: 46.3px;
            width: 333px;
            border: 1px solid #979797;
            background-color: #ffffff;
            margin: auto;
            margin-top: 30px;
      }
      .pwd_inp{
        box-sizing: border-box;
      height: 46.3px;
      width: 333px;
      border: 1px solid #979797;
      background-color: #ffffff;
      margin: auto;
      margin-top: 13px;
      }
      .wlcm_class {
        color: #333333;
        margin-top: 32px;
        font-family: Aleo;
        font-size: 33px;
        font-style: italic;
        letter-spacing: 1.83px;
        line-height: 40px;
        text-align: center;
        // @media (max-width:1023px) {
        //   margin-top: 35px;
        //   margin-bottom: 11px;
        // }
      }
      .input_placeholder::placeholder {
        font-family: Montserrat;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        letter-spacing: 0.04px;
        color: #a4a4a4 !important;
        opacity: 1;
      }
    }
    .abc {
      height: 346px !important;
      padding: 20px;
      border-top-left-radius: 11px;
      // @media (max-width: 1023px) {
      //   height: calc(100% - 584px) !important;
      // }
      @media (min-width:1387px) and (min-height:850px){
        height: 224px !important;
      }
    }
    .images{
      max-height: 510px !important;
    }
  }
}
</style>
